import React from 'react';
import {
  TimeEntryChangeRequest,
  TimeEntry,
  Employee,
} from '../../../__generated__/graphql';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import LightList from '../../../components/LightList';
import { routes } from '../../../routes';
import { SectionTitle } from '../Heading';
import WorkingTimeDiff from '../../../components/TimeEntryChangeRequest/WorkingTimeDiff';
import Button from '../../../../../components/button';
import { useHistory } from 'react-router-dom';
import { useManagerReportsMode } from '../../../hooks/useManagerReportsMode';

type EmployeeProps = Pick<Employee, 'Name'>;
type TimeEntryProps = Pick<TimeEntry, 'flair__Working_Period_In_Hours__c'>;
type TimeEntryChangeRequestProps = Pick<
  TimeEntryChangeRequest,
  'Id' | 'flair__Working_Period_In_Hours__c'
> & { timeEntry: TimeEntryProps | null } & { employee: EmployeeProps };

type Props = {
  changeRequests: ReadonlyArray<TimeEntryChangeRequestProps>;
};

const PendingTimeEntryChangeRequests: React.FC<Props> = ({
  changeRequests,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [myTeamReportMode] = useManagerReportsMode('myteam');
  const [targetReportMode, setTargetReportsMode] = useManagerReportsMode(
    'pendingTimeEntryChangeRequests',
  );

  const items = changeRequests.map((cr) => ({
    key: cr.Id,
    name: cr.employee.Name,
    value: (
      <WorkingTimeDiff
        oldValue={cr.timeEntry?.flair__Working_Period_In_Hours__c ?? null}
        newValue={cr.flair__Working_Period_In_Hours__c}
      />
    ),
  }));

  const count = changeRequests.length;

  return (
    <Row>
      <Col xs={12} className="mb-1">
        <SectionTitle>
          {t('home.pendingApprovalCard.pendingTimeEntryChangeRequests.title', {
            count: count,
          })}
        </SectionTitle>
      </Col>
      <Col>
        <LightList
          items={items}
          actionLink={
            <Button
              variant="link"
              size="sm"
              className="p-0 m-0"
              label={t(
                'home.pendingApprovalCard.pendingTimeEntryChangeRequests.actionLink',
              )}
              onClick={() => {
                // set manager mode to the same as in myTeam page
                if (myTeamReportMode !== targetReportMode) {
                  setTargetReportsMode(myTeamReportMode);
                }
                history.push(
                  routes.pendingTimeEntryChangeRequests.route.create({}),
                );
              }}
            />
          }
        />
      </Col>
    </Row>
  );
};

export default PendingTimeEntryChangeRequests;
